/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailLogsSearchRequest } from '../models/EmailLogsSearchRequest';
import type { EmailLogsSearchResponse } from '../models/EmailLogsSearchResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmailClient {

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static emailInitialize(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/email/initialize',
        });
    }

    /**
     * @param requestBody
     * @returns EmailLogsSearchResponse Success
     * @throws ApiError
     */
    public static searchEmailLogs(
        requestBody?: EmailLogsSearchRequest,
    ): CancelablePromise<EmailLogsSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/email/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}
